import { DefaultTheme } from 'styled-components';
import { getSpacingToken, getToken, Size } from '@optimus-web/common';

export const getInputContainerHeight = ({ inputSize }: { inputSize?: Size }) => {
    switch (inputSize) {
        case 'small':
            return getToken('sizing400');
        case 'medium':
            return getToken('sizing500');
        case 'large':
            return getToken('sizing600');
        case 'extraLarge':
            return getToken('sizing700');
        default:
            return getToken('sizing500');
    }
};

export const getInputPadding = ({ inputSize }: { inputSize?: Size }) => {
    switch (inputSize) {
        case 'small':
            return getSpacingToken('50');
        case 'medium':
            return getSpacingToken('100');
        case 'large':
            return getSpacingToken('150');
        case 'extraLarge':
            return getSpacingToken('200');
        default:
            return getSpacingToken('100');
    }
};

export const getContainerPadding = ({ inputSize }: { inputSize?: Size }) => {
    switch (inputSize) {
        case 'small':
            return getSpacingToken('100');
        case 'medium':
            return getSpacingToken('150');
        case 'large':
            return getSpacingToken('200');
        case 'extraLarge':
            return getSpacingToken('200');
        default:
            return getSpacingToken('150');
    }
};

export const getInputColor = ({
    disabled,
    readOnly,
    theme,
}: {
    disabled?: boolean;
    readOnly?: boolean;
    theme: DefaultTheme;
}) => {
    if (disabled) {
        return getToken('textDisabled')({ theme });
    } else if (readOnly) {
        return getToken('textStaticSecondary')({ theme });
    }

    return getToken('textStaticPrimary')({ theme });
};
